import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import ThinkLab from '../components/ThinkLab';
import { Toaster } from '../components/ui/toaster';

const ThinkLabPopup = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session') || 'popup-session';
  const sessionTitle = searchParams.get('title') || 'Popup Session';

  // State for popup (simplified - no parent context needed)
  const [timerActive, setTimerActive] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [trackingEnabled, setTrackingEnabled] = useState(false);
  const [activeReading, setActiveReading] = useState(null);
  const [trackedReadings, setTrackedReadings] = useState([]);
  const [activeTab, setActiveTab] = useState('brainstorm');

  // Sync with localStorage for cross-window communication
  useEffect(() => {
    const checkStorage = () => {
      try {
        const storedTimer = localStorage.getItem('thinklab_timer');
        const storedTracking = localStorage.getItem('thinklab_tracking');
        
        if (storedTimer) {
          const timer = JSON.parse(storedTimer);
          setTimerActive(timer.active);
          setTimeRemaining(timer.remaining);
        }
        
        if (storedTracking) {
          const tracking = JSON.parse(storedTracking);
          setTrackingEnabled(tracking.enabled);
          setActiveReading(tracking.activeReading);
        }
      } catch (e) {
        console.error('Storage sync error:', e);
      }
    };

    // Initial check
    checkStorage();

    // Listen for storage changes
    window.addEventListener('storage', checkStorage);
    
    // Poll every 2 seconds
    const interval = setInterval(checkStorage, 2000);

    return () => {
      window.removeEventListener('storage', checkStorage);
      clearInterval(interval);
    };
  }, []);

  // Update localStorage when state changes
  useEffect(() => {
    if (timerActive !== null) {
      localStorage.setItem('thinklab_timer', JSON.stringify({
        active: timerActive,
        remaining: timeRemaining
      }));
    }
  }, [timerActive, timeRemaining]);

  useEffect(() => {
    localStorage.setItem('thinklab_tracking', JSON.stringify({
      enabled: trackingEnabled,
      activeReading: activeReading
    }));
  }, [trackingEnabled, activeReading]);

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Popup Header */}
      <div className="bg-gradient-to-r from-purple-600 to-pink-600 text-white p-3 text-center">
        <p className="text-sm font-semibold">🪟 Think Lab Popup - Stay productive while browsing!</p>
      </div>

      {/* Think Lab in always-open mode */}
      <div className="p-4">
        <ThinkLab
          sessionId={sessionId}
          sessionTitle={sessionTitle}
          isOpen={true}
          onClose={() => window.close()}
          timerActive={timerActive}
          setTimerActive={setTimerActive}
          timeRemaining={timeRemaining}
          setTimeRemaining={setTimeRemaining}
          trackingEnabled={trackingEnabled}
          setTrackingEnabled={setTrackingEnabled}
          activeReading={activeReading}
          setActiveReading={setActiveReading}
          trackedReadings={trackedReadings}
          setTrackedReadings={setTrackedReadings}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>

      <Toaster />
    </div>
  );
};

export default ThinkLabPopup;
